<script setup>
/**
 * App - 루트 컴포넌트. RouterView 단일이고 레이아웃은 라우트 layout meta 로 분기한다.
 * InToastHost 를 1회 마운트하고, 로그인 시 화면 환경(개인 테마·화면 언어)을 서버 값으로 맞춘다.
 */
import { onMounted, watch } from 'vue';
import InToastHost from '@/components/ui/InToastHost.vue';
import { useAuthStore } from '@/stores/auth';
import { useThemeStore, DEFAULT_THEME } from '@/stores/theme';
import { useLocale } from '@/composables/useLocale';
import { myProfileRepo } from '@/services/auth';
import { prefRepo } from '@/services/me';

const auth = useAuthStore();
const themeStore = useThemeStore();
const locale = useLocale();

// 화면 환경을 현재 세션에 적용한다. 체인을 판정하는 곳은 여기 한 곳뿐이다.
//   테마 = 개인 -> 시스템 기본(white)          회사 단위 기본값은 두지 않는다
//   언어 = 개인 -> 회사 대표 언어 -> ko        회사 축은 I18N0010(기획서 S34~S38) 소관
// 두 조회는 서로 독립이라 개별로 실패시킨다. 하나가 죽어도 나머지는 적용된다.
let bootSeq = 0;
async function applyEnv() {
  if (!auth.isLoggedIn) return;
  const seq = ++bootSeq;
  const [me, mine] = await Promise.all([
    myProfileRepo.me().catch(() => null),
    prefRepo.load().catch(() => null),
  ]);
  // 기다리는 사이 로그아웃·재로그인했으면 이전 사용자 값을 되쓰지 않는다.
  if (seq !== bootSeq || !auth.isLoggedIn) return;
  // 조회 실패(null)와 "서버에 설정이 없음"(필드 null)은 다르다. 실패면 기기 저장값을 그대로 둔다.
  if (mine) themeStore.setTheme(mine.themeCd || DEFAULT_THEME);
  if (mine?.localeCd || me) await locale.resolve(mine?.localeCd, me?.mainLocaleCd);
}

onMounted(applyEnv);
watch(() => auth.isLoggedIn, (v) => { if (v) applyEnv(); });
</script>

<template>
  <div style="display: contents">
    <RouterView />
    <InToastHost />
  </div>
</template>
